<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">科创教育有几种解法？这场新年大会探索“科学+”的无限可能！</div>
      <div class="news-date">2025年1月8日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/ai_logo.gif"/>
          </div>
        </div>
        <p>2024年12月31日晚，由上海市科委、上海市教委指导，上海科技馆、腾讯公益慈善基金会主办的“科际穿越·科创校长空间站”科学新年大会暨腾讯科技之夜在上海自然博物馆（上海科技馆分馆）举办。在活动主会场，演讲、对谈、实验等节目精彩上演，正式发布的“一平米博物馆开放计划”让博物馆资源进社区、进乡村，惠及更多市民群众；在博物馆各处，以趣逛、趣玩、趣购为主要内容的博物馆之夜，为观众带来了沉浸式、立体式的科普大餐；120多位偏远乡村女孩、城市流动儿童和患儿家庭走进博物馆，近距离探秘科学世界……这不仅是上海科技馆与腾讯深度合作的开端，更是对科创教育未来、跨界公益创新的一次探索与展望。</p>
        <div class="news-content-mark">
          <div>1 专家讲座，让前沿科学流行起来</div>
        </div>
        <p>活动以蓝毯仪式启幕，在动物标本环绕下，来自科技创新和科学普及的“两翼”的群星“踏浪而来”，分享他们对科创教育的独到见解。活动现场，不同领域的科学家、人文艺术家，科创校长空间站联盟校的校长们，以及来自上海各区的教育局长们，共同探讨和分享科创教育的最新动态和未来趋势。在揭秘环节，来自上海各区的教育局局长们分享他们2024年的科技关键词以及对未来教育的展望和期待。在讲座环节中，各界大咖跨界分享各自领域中科创的意义与成果，为观众解锁多维科学教育内容。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news75.webp"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>2 形式突破，让科创教育“活”起来</div>
        </div>
        <p>本次活动积极探索科普传播的多元化形式，引领广大观众走近科学。其中，实验在科学研究中扮演着至关重要的角色，是探索与发现的基石，用趣味实验形式，让孩子们保持积极体验的好奇心，是科创教育的一大关键。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news75/news75_1.webp"/>
          </div>
        </div>
        <p>
          活动现场，
          <span class="mark-text highlight">腾讯华东总部联合腾讯优图实验室带来全新的AI照相馆互动体验，吸引了许多小朋友体验AI技术的魅力。</span>
          AI照相馆基于腾讯优图实验室自研的图生图技术，将参观者现场拍摄的照片转化成动漫、3D、水彩、插画、黏土、玉石等多样风格，并针对人像效果重点适配优化，使生成结果更加稳定、美观。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news75/news75_2.webp"/>
            <img class="news-image" src="../img/detail/activity/news75/news75_3.webp"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>3 跨界对谈，让科创教育引领未来</div>
        </div>
        <p>新兴技术将如何改变我们科创教育？应当如何推动多元主体协同进行科创教育？这些问题决定着科创教育的发展方向。在科学新年大会上，来自场馆、高校、学校、企业等科创教育主体的各界人士共话科创教育。中国教育学会副会长、江苏省锡中教育集团总校长唐江澎结合2024年的科技界热点“人工智能”谈拔尖人才的培养。在“科创校长空间站”核心环节“馆长有约”跨界对谈中，全国政协委员、上海科技馆馆长倪闽景主持，全国政协委员、奥运会女子10米气手枪冠军陶璐娜，腾讯可持续社会价值副总裁、腾讯公益慈善基金会秘书长葛燄，同济大学副校长娄永琪，华师大二附中闵行紫竹分校、华二附属初级中学校长施洪亮就科创教育的未来发问，共同探讨不同领域如何携手推动科创教育。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news75/news75_4.webp"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>4 科技+公益，让优质科技资源惠及更广人群</div>
        </div>
        <p>这个夜晚，由腾讯公益慈善基金会携手上海科技馆共同支持、恩派公益基金会组织承办，邀请到120多位偏远乡村女孩、城市流动儿童和患儿家庭走进自然博物馆，他们在机构伙伴和爱心志愿者的陪伴下，在博物馆中探索生命的奥秘，领略“缤纷生命”的多样与奇妙，亲身体验“非洲”风情、木偶剧的欢乐，与科学亲密接触。自然博物馆的奇妙之夜，让孩子们增长见识、开拓视野，也在他们心中种下了创新思维和科学梦想。葛燄表示，未来，腾讯公益慈善基金会希望连接更多优质的社会公共服务资源、公益组织和公益项目，让优质的公共服务资源进入公益场景，让热门的展览、剧演、文化项目，以最直接和专业的方式服务到“一老一小”和弱势群体等人群。通过多方努力，探索可持续的公益跨界共建模式，让更多的孩子有机会体验文化、艺术和科技，享受到更多更优质的社会公共服务。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news75/news75_5.png"/>
          </div>
        </div>
        <p>活动现场，由上海科技馆和腾讯公益慈善基金会合作的“一平米博物馆开放计划”正式发布，上海科技馆科学传播中心副主任、研究员宋娴表示，该计划旨在打破博物馆的“有限”围墙，让更多博物馆的优质资源“走出去”，实现科学文化的“无限”共享。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news75/news75_6.webp"/>
          </div>
        </div>
        <p>除了让更多市民群众“走进去”，还可以让馆院资源“走出来”。此次腾讯基金会和上海科技馆三馆的合作，在公共空间设置 “一平米博物馆”，让科普知识和一些珍贵的藏品走进乡村、社区、医院、学校、企业等博物馆以外的场景，惠及更多老人和孩子们。社会捐赠人也可以加入开放计划，出资为所在社区、孩子的学校、自己的公司或者医院建立“一平米博物馆”，从而开创一个让捐赠人、受益人、志愿者都可参与的新模式。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news75/news75_7.png"/>
          </div>
        </div>
        <p>此次活动是“科际穿越·科创校长空间站”第二次成功举办年度大会。自2023年6月扬帆启航以来，“科创校长空间站”已稳健“着陆”于科技馆、图书馆、学校、科技节、博览会等多元场景，成功举办24场精彩纷呈的大型综合性科普活动，邀请诺贝尔奖得主、中国科学院院士、杰出教育家、科创企业家等数十位重量级嘉宾，携手全市16个区的教育局及教育管理部门，凝聚科技场馆、中小学校、高校、科研院所、科创企业、社会机构等多方力量，共同探索科创教育的崭新路径与未来愿景。</p>
        <p>上海科技馆与腾讯公益慈善基金会也将携手并进，在2025年联合推进“一平米博物馆”、科学桌游等合作项目，让科学的种子在更多人心中生根发芽。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News75.vue